(function () {
  var source = document.currentScript.getAttribute('data-recommendation-src');
  var loading = false;
  var cartPending = false;
  var cartEvents = ['theme:cartchanged', 'theme:open-cart-drawer', 'theme:cart-add', 'theme:cart-change', 'theme:cart-update'];

  function loadRecommendations() {
    if (loading || !source) return;
    loading = true;
    var script = document.createElement('script');
    script.src = source;
    script.onload = function () {
      cartEvents.forEach(function (name) { document.removeEventListener(name, onCartEvent); });
      document.removeEventListener('pointerover', onCartIntent);
      document.removeEventListener('focusin', onCartIntent);
      // The bundle now owns cart events. Preserve a cart action during its download
      // without replaying that action to unrelated cart handlers.
      if (cartPending) document.dispatchEvent(new CustomEvent('sop:recommendations-cart-ready'));
    };
    script.onerror = function () {
      loading = false;
      script.remove();
    };
    document.head.appendChild(script);
  }

  function onCartEvent(event) {
    cartPending = cartPending || event.type === 'theme:cartchanged' || !!(event.detail && !event.detail.isEmpty);
    if (cartPending) loadRecommendations();
  }

  function onCartIntent(event) {
    if (event.target.closest && event.target.closest('#cart-icon-bubble')) loadRecommendations();
  }

  cartEvents.forEach(function (name) { document.addEventListener(name, onCartEvent); });
  document.addEventListener('pointerover', onCartIntent);
  document.addEventListener('focusin', onCartIntent);

  // Keep any on-page recommendation widgets working on custom templates too.
  if (document.querySelector('#graphene-recommendation-container, #graphene-recommendation-container-2')) {
    loadRecommendations();
  }
})();
